import { formatRevenue } from "features/Common/utils/common.utils";

export const apiKeys = {
  campaignName: "title",
  trigger: "trigger_type",
  totalSubscribers: "total_subscribers",
  emails: "no_of_emails",
  totalEmailsSent: "total_sent_to_count",
  totalOpenCount: "total_opened_count",
  unsubscribedCount: "unsubscribe_count",
  offeringName: "listing_title",
  totalClicksNumber: "total_clicks_number",
  totalHyperlinks: "total_hyperlinks",
  subscribeTriggerCount: "subscribe_trigger_count",
  unsubscribeTriggerCount: "unsubscribe_trigger_count",
  clickRate: "click_rate",
  Bookings: "total_bookings",
  Revenue: "total_revenue",
};

export const fieldConfig = [
  {
    label: "Campaign name",
    source: apiKeys.campaignName,
  },
  {
    label: "Triggers",
    source: apiKeys.trigger,
    format: (data) =>
      `${data[apiKeys.subscribeTriggerCount]} subscribe, ${
        data[apiKeys.unsubscribeTriggerCount]
      } unsubscribe`,
  },
  {
    label: "Emails",
    source: apiKeys.emails,
  },
  {
    label: "Bookings",
    source: apiKeys.Bookings,
    mobileOnly: true,
    format: (data) => data[apiKeys.Bookings] || 0,
  },
  {
    label: "Revenue",
    source: apiKeys.Revenue,
    mobileOnly: true,
    format: (data) => formatRevenue(data[apiKeys.Revenue]),
  },
];

export const getDripHeader = (data) => data[apiKeys.campaignName];
